import { SET_NOTIFICATION_COUNTER } from '../actions/notificationCounter';

const initialState = {
  notificationCounter: false,
};

const notificationCounterReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case  SET_NOTIFICATION_COUNTER:
      return {
        ...state,
        notificationCounter: action.payload,
      };
    default:
      return state;
  }
};

export default notificationCounterReducer;
